import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_BG.json';
import audios from './ASTROLOGY_AUDIOS_BG.json';

export const ASTROLOGY_DATA_BG: ServiceData = {
  articles,
  audios,
};
